import React from 'react';
import './SmallDescription.css';

const SmallDescription = ({ title, details }) => {
  // Function to format details text
  const formatDetails = (text) => {
    const sentences = text.split('. '); // Split by ". "
    let formattedText = '';
    let lineCount = 0;

    sentences.forEach((sentence, index) => {
      if (lineCount === 3) {
        formattedText += `<br/><br/>`; // Add a gap of one line
        lineCount = 0;
      }
      formattedText += sentence + (index !== sentences.length - 1 ? '. ' : '');
      lineCount++;
    });

    return formattedText;
  };

  return (
    <div className="SmallDescription-container">
      <h1 className="SmallDescription-title">{title}</h1>
      <p
        className="SmallDescription-Details"
        dangerouslySetInnerHTML={{ __html: formatDetails(details) }}
      />
    </div>
  );
};

export default SmallDescription;
